import { defineComponent, ref } from 'vue';
import loadingGif from '@/assets/image/home/imgLoading.gif';
import failPng from '@/assets/image/home/imgDownloadFail.png';
export default defineComponent({
  name: 'Image',
  props: {
    src: {
      type: String,
      required: true
    },
    alt: {
      type: String
    }
  },
  setup: function (props) {
    var srcRef = ref(loadingGif);
    var loadImg = new Image();
    loadImg.onload = function () {
      srcRef.value = props.src;
    };
    loadImg.onerror = function () {
      srcRef.value = failPng;
    };
    loadImg.src = props.src;
    return {
      srcRef: srcRef
    };
  }
});